export const PLACEMENT_TEST_VERSION = '2026-07-25-v1';

const ATTEMPT_ID_PATTERN = /^[A-Za-z0-9_-]{8,80}$/;

export function createPlacementAttemptId() {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }

  const randomPart = Math.random().toString(36).slice(2);
  return `placement_${Date.now().toString(36)}_${randomPart}`;
}

export function buildPlacementAttemptResult({
  summary,
  answers,
  attemptId = createPlacementAttemptId(),
}) {
  if (!summary || typeof summary !== 'object') {
    throw new TypeError('A placement result summary is required.');
  }
  if (!ATTEMPT_ID_PATTERN.test(attemptId)) {
    throw new TypeError('The placement attempt id is invalid.');
  }

  const responses = (Array.isArray(answers) ? answers : []).map((answer, index) => ({
    questionId: String(answer?.questionId || '').trim(),
    answerId: String(answer?.answerId || '').trim(),
    sequence: index + 1,
  }));

  return {
    ...summary,
    attemptId,
    testVersion: PLACEMENT_TEST_VERSION,
    responses,
  };
}

export function buildPlacementAttemptSubmission(result) {
  if (!result || typeof result !== 'object') return result;

  return {
    ...result,
    correctAnswers: result.correctAnswers ?? result.correct,
    totalQuestions: result.totalQuestions ?? result.total,
  };
}

export function getPlacementResultProfileSummary(result, diagnosticAttemptId = null) {
  if (!result || typeof result !== 'object') return null;

  const summary = { ...result };
  delete summary.responses;
  delete summary.testVersion;
  delete summary.attemptId;

  return {
    ...summary,
    ...(diagnosticAttemptId ? { diagnosticAttemptId } : {}),
  };
}
